<template>
  <div class="col-lg-12 control-section">
    <div class="h-toolbarBg">
      <ejs-toolbar>
        <e-items>
          <!--<e-item prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("MCS.add")' :click="addClk"></e-item>-->
          <e-item prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("MCS.mod")' :click='modifyClk'></e-item>
          <!--<e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("MCS.del")' :click="delClk"></e-item>-->
        </e-items>
      </ejs-toolbar>
      </div>
      <ejs-treegrid ref='deployGrid' :dataSource='data' idMapping='id' parentIdMapping='parentItem' hasChildMapping='parent' :treeColumnIndex='1' height='520' :editSettings  ='editSettings' :allowRowDragAndDrop="false"  :selectionSettings="selection" :toolbar='toolbarOptions'>
        <e-columns>
          <e-column field='id' headerText='id' width='80' textAlign='Right' isPrimaryKey='true' :visible='true' :formatter='idFormat'></e-column>
          <!--<e-column width='10'></e-column>-->
          <e-column field='type' :headerText='$t("DeployManagement.type")' width='50'  editType= 'stringedit' ></e-column>
          <e-column field='serviceName' :headerText='$t("DeployManagement.name")' width='50'  editType= 'stringedit'></e-column>
         <!-- <e-column field='StartDate' headerText='Start Date' width='100' format="yMd"  editType='datepickeredit' textAlign='Right' :validationRules='startdaterules'></e-column>
          <e-column field='EndDate' headerText='End Date' width='100' format="yMd"  editType='datepickeredit' textAlign='Right' :validationRules='startdaterules'></e-column>-->
          <e-column field='value' :headerText='$t("DeployManagement.value")' width='185' editType='stringedit'></e-column>
          <e-column field='parentItem' headerText='parentItem' :visible='false'></e-column>
          <!--<e-column field='Progress' headerText='Progress' width='85' textAlign='Right' :edit='editparams'  editType= 'numericedit' :validationRules='progressrules'></e-column>-->
        </e-columns>
      </ejs-treegrid>
      <!--<ejs-treegrid :dataSource='data' idMapping='TaskID' parentIdMapping='ParentItem' hasChildMapping='isParent' :treeColumnIndex='1' :allowPaging='true' :pageSettings='pageSettings'>
        <e-columns>
          <e-column field='TaskID' headerText='Task ID' width='100' textAlign='Right'></e-column>
          <e-column field='TaskName' headerText='Task Name' width='160'></e-column>
          <e-column field='StartDate' headerText='Start Date' width='140' format="yMd" textAlign='Right'></e-column>
          <e-column field='EndDate' headerText='End Date' width='140' format="yMd" textAlign='Right'></e-column>
          <e-column field='Duration' headerText='Duration' width='120' textAlign='Right'></e-column>
          <e-column field='Progress' headerText='Progress' width='110'></e-column>
        </e-columns>
      </ejs-treegrid>-->
   <!-- <CustomDialog ref='updateDevice' :element='updateDevDialog.element' :styles='updateDevDialog.styles' :messages='updateDevDialog.messages'>
      <template v-slot:dialog-content>
        <UpdateDevice ref="updatedev" ></UpdateDevice>
      </template>
    </CustomDialog>-->
    <CustomDialog ref='editTemplate' :element='editTemplateDialog.element' :styles='editTemplateDialog.styles' :messages='editTemplateDialog.messages'>
      <template v-slot:dialog-content>
        <EditTemplate ref="editTemplateDev" :formParams='formParams' :opCode='opCode'></EditTemplate>
      </template>
    </CustomDialog>
    </div>


</template>

<script>
import Vue from 'vue';
import { TreeGridPlugin, Edit, Page, Toolbar, TreeGridComponent, Selection, RowDD } from '@syncfusion/ej2-vue-treegrid';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import CustomDialog from '../../../../common/CustomDialog';
import EditTemplate from './EditTemplate';
import UpdateDevice from '../../../../topoconfig/UpdateDevice';
import { EventBus } from '../../../../../plugins/eventBus';

Vue.use(TreeGridPlugin, DropDownListPlugin);

export default {
  name: 'OneKeyDeploymentEdit',
  components: {
    CustomDialog,
    EditTemplate
  },
  data() {
    return {
      data: [],
      editSettings: {
        allowEditing: false,
        allowAdding: false,
        allowDeleting: false,
        mode: 'Row',
        allowEditOnDblClick: false,
        showConfirmDialog: false,
        showDeleteConfirmDialog: false
      },
      toolbarOptions: ['Search'],
      // toolbar: ['Add', 'Edit', 'Delete'],
      // selection: { type: 'Multiple' },
      selection: { type: 'Single' },
      editTemplateDialog:{
        element: {
          title:  `${this.$t('DeployManagement.editTemplate')}`,
          // target: '#app',
          isClose: true,
          refName: this.$t('Topo.devMange'),
          buttonGroup: [
            { click: this.closeEditTemplateDialog, buttonModel: { content: this.$t('Topo.cancel') } },
            { click: this.getEditData, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } }
          ]
        },
        styles: {
          width: '500px',
          height: '600px',
          visible: false,
          model: true,
          zIndex:1212
        },
        messages: {
          title: `${this.$t('DeployManagement.editTemplate')}`,
        }
      },
      dpParameterRule: {}, // 校验规则json
      dpPmsMap: new Map(), // 存储pms信息，key:pms json中的name, value: 页面可显示的pms json对象
      oldDataMap: new Map(), // 存储treeGrid表格数据的Map,供更新数据使用，key:id ; value:表格数据
      newDataMap: new Map(), // 修改过的数据，供保存使用，key:id, value ：更新过的表格数据
      selectedDataRule: [], // 记录每次选择表格的校验json数组
      formParams: [], // 每次弹窗修改模板的数据json
      selectedRowIndex: 0, // 选中行的下标
      selectedRowId: 0, // 选中行id
      opCode: '0', // 0增加 1修改
      templateContent: '',
      processName: 'ems_micropoc',
      content: '',
      environmentId: '',
      hasDeployed: false //false未部署 true已部署
    };
  },
  provide: {
    treegrid: [ Edit, Page, Selection, RowDD]
  },
  methods: {
    idFormat(grids, data) {
      if (data.type !== 'PMS'){
        return data.id;
      }
    },
    getTemplateContent(checkData) {
      this.templateContent = checkData.deploymentTemplate;
      this.content = checkData.content;
      this.environmentId = checkData.id;
    },
    /*setData(){
      this.formParams = [{
        "uiIndex": 1,
        "showName": "id",
        "hidden": false,
        //"modifyShow": false,
        //"couldBatchMod": false,
        //"tempFlag": false,
        //"groupBy": "base",
        "type": "text",
       // "changeClick": false,
       // "couldMod": false,
        //"batch_hidden": false,
        "readonly": true,
        "name": "id",
        "id": "id",
        "placeholder": "1-1000",
        "value": "1",
        "validate": {
          "required": [true, "该项不能为空"],
          "number": 1,
          "min": 1,
          "max": 4294967295
        }
      }, {
        "uiIndex": 1,
        "showName": "节点类型",
        "hidden": false,
        "modifyShow": true,
        "couldBatchMod": false,
        "tempFlag": false,
        "groupBy": "base",
        "type": "radio",
        "changeClick": false,
        "couldMod": false,
        "batch_hidden": false,
        "readonly": false,
        "name": "type",
        "id": "type",
        "placeholder": "类型",
        "value": "",
        "validate": {
          "required": [true, "该项不能为空"],
        },
        "options": [
          {
            "showName": "MASTER",
            "value": "MASTER"
          },
          {
            "showName": "NODE",
            "value": "NODE"
          }
        ]
      }];
    },*/
    delClk(){
      const item = this.$refs.deployGrid.getSelectedRecords();
      this.$refs.deployGrid.deleteRecord("Id");
    },
    addClk() {
      // this.$refs.editTemplate.show();
      const item = this.$refs.deployGrid.getSelectedRecords();
      if (item.length === 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.pleaseSelectOneData') });
        return;
      }
      this.$refs.deployGrid.addRecord(null, item[0].index+1);

      // this.$refs.deployGrid.addRecord({ "ParentItem": item[0].Id+1 }, item[0].index+1);
    },
    modifyClk() {
      if (this.hasDeployed) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.cannotEditTemplate') });
        return;
      }
      const item = this.$refs.deployGrid.getSelectedRecords();
      if (item.length === 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.pleaseSelectOneData') });
        return;
      }
      this.selectedRowId = item[0].id;
      this.selectedRowIndex = this.$refs.deployGrid.getSelectedRowIndexes()[0];
      if (item.length === 1) {
        this.selectedDataRule = [];
        this.formParams = [];
        this.$refs.editTemplateDev.$forceUpdate();
        if (item[0].type === 'PMS') {
          //this.formParams = [];
          const pmsRuleObj = this.dpPmsMap.get(item[0].value.split('=')[0]);
          pmsRuleObj.value = item[0].value.split('=')[1];

          //this.$refs.editTemplateDev.setData("id", item[0].value.split('=')[1]);// 投机取巧，解决参数赋值问题
          /*for (let key of this.$refs.editTemplateDev.getDatas().keys()) {
            this.$refs.editTemplateDev.setData(key, item[0].value.split('=')[1]);
            break;
          }
*/

          this.selectedDataRule.push(pmsRuleObj);

        } else {
          // 投机取巧，解决参数赋值问题
          /*for (let key of this.$refs.editTemplateDev.getDatas().keys()) {
            this.$refs.editTemplateDev.setData(key, item[0].id);
            break;
          }
*/
          if (item[0].type === 'MASTER' || item[0].type === 'NODE') {
            this.selectedDataRule = this.dpParameterRule.k8s;
          } else if (item[0].type === 'POD') {
            this.selectedDataRule = this.dpParameterRule.pod;
            // this.formParams = this.dpParameterRule.pod;
          } else if (item[0].type === 'BASE' || item[0].type === 'CORE') {
            this.selectedDataRule = this.dpParameterRule.service;
            // this.formParams = this.dpParameterRule.service;
          }

          // 编辑页面展示已有的值
          for (let i = 0; i < this.selectedDataRule.length; i++) {
            if (this.selectedDataRule[i].name === 'id') {
              this.selectedDataRule[i].value = item[0].id;
              this.$refs.editTemplateDev.setData(this.selectedDataRule[i].name, item[0].id);

            } else if (this.selectedDataRule[i].name === 'type') {
              this.selectedDataRule[i].value = item[0].type;
              this.$refs.editTemplateDev.setData(this.selectedDataRule[i].name, item[0].type);

            } else if (this.selectedDataRule[i].name === 'name') {
              this.selectedDataRule[i].value = item[0].value.split(',')[0].split('=')[1];
              this.$refs.editTemplateDev.setData(this.selectedDataRule[i].name, item[0].type);

            } else if (this.selectedDataRule[i].name === 'desc') {
              this.selectedDataRule[i].value = item[0].value.split(',')[1].split('=')[1];
              this.$refs.editTemplateDev.setData(this.selectedDataRule[i].name, item[0].value.split(',')[1].split('=')[1]);

            } else if (this.selectedDataRule[i].name === 'serviceName') {
              this.selectedDataRule[i].value = item[0].serviceName;
              this.$refs.editTemplateDev.setData(this.selectedDataRule[i].name, item[0].serviceName);

            } else if (this.selectedDataRule[i].name === 'version') {
              this.selectedDataRule[i].value = item[0].version;
              this.$refs.editTemplateDev.setData(this.selectedDataRule[i].name, item[0].version);

            }
          }
        }
        //form表单初始化
        this.$refs.editTemplateDev.$nextTick(() => {
          this.formParams = this.selectedDataRule;
        });

        this.$refs.editTemplateDev.$forceUpdate();
        this.$refs.editTemplate.show();
      }
      if (item.length === 0) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.pleaseSelectOneData') });
        return;
      }
    },
    closeEditTemplateDialog() {
      this.$refs.editTemplate.clear();
      this.$refs.editTemplate.close();
    },
    // 获取部署模板内容并转化为表格展示的形式
    getDeployTemplate(item) {
      this.$loading.showLoadding(`${this.$t('DeployManagement.getDeployedTemplateTips')}`);
      const $this = this;
      const param = {
        id: item.id
      };
      this.$axios.post('/lte/ems/env/getDeployTemplate.html', param).then((response) => {
        if (response && response.status === 200) {
          this.$loading.hideLoadding();

          if (response.data.errorCode === 'SUCCESS') {
            $this.data = eval(response.data.resultVal);
            // EventBus.$emit('toast', { type: 'success', content: "获取模板成功" });
            // EventBus.$emit('toast', { type: 'success', content: this.$t('Common.tips.success') });
            $this.getDpParameterRuleJson(item);
            $this.arrayToMap($this.data);
          } else {
            EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.getDeployedTemplateFailed') });
          }
        }
      });
    },
    getDpParameterRuleJson(item) {
      const $this = this;
      const param = {
        dpSoftVersion: item.dpSoftVersion
      };
      this.$axios.post('/lte/ems/env/getDpParameterRule.html', param).then((response) => {
        if (response && response.status === 200) {
          if (response.data.errorCode === 'SUCCESS') {
            // console.log(response.data.resultVal);
            $this.dpParameterRule = JSON.parse(response.data.resultVal);
            $this.dpParameterRule.k8s.forEach((val, index)=> {
               val['hidden'] = false;
            });
            $this.dpParameterRule.pod.forEach((val, index)=> {
              val['hidden'] = false;
            });
            $this.dpParameterRule.service.forEach((val, index)=> {
              val['hidden'] = false;
            });
            $this.dpParameterRule.pms.forEach((val, index)=> {
              val['hidden'] = false;
              $this.dpPmsMap.set(val.name, val);
            });
          } else {
            EventBus.$emit('toast', { type: 'warning', content: this.$t('DeployManagement.getTemplateRuleJsonFailed') });
          }
        }
      });
    },
    arrayToMap(result) {
      for (let i = 0; i < result.length; i++) {
        this.oldDataMap.set(result[i].id, result[i]);
      }
    },
    getEditData() {
      const validateReturn = this.$refs.editTemplateDev.validateResult();
      if (!validateReturn) {
        console.log('表单验证不通过');
        return false;
      }
      const newDatas = this.$refs.editTemplateDev.getDatas();
      console.log(this.$refs.editTemplateDev.getDatas());
      let oldObj = this.oldDataMap.get(newDatas.get('id'));
      if (newDatas.get('serviceName')) {
        oldObj.value = `name=${newDatas.get('name')},desc=${newDatas.get('desc')}`;
        this.newDataMap.set(newDatas.get('id'), oldObj);
        Vue.set(this.data, this.selectedRowIndex, oldObj);
        this.$refs.deployGrid.setRowData(newDatas.get('id'), oldObj);
      } else {
        for (let key of newDatas.keys()) {
          oldObj = this.oldDataMap.get(this.selectedRowId);
          //oldObj.value = `${oldObj.value.split("=")[0]}=${newDatas.get(key)}`;
          if(key === oldObj.value.split("=")[0]){
            oldObj.value = `${key}=${newDatas.get(key)}`;
            this.newDataMap.set(`${key},${oldObj.parentItem}`, oldObj);//INSTALL_PKG_PATH,1
            Vue.set(this.data, this.selectedRowIndex, oldObj);
            this.$refs.deployGrid.setRowData(this.selectedRowId, oldObj);
          }
        }
      }


      this.closeEditTemplateDialog();
    },
    getData() {
      const content = JSON.parse(this.content);
      // map转object
      let obj = Object.create(null);
      for (let[k,v] of this.newDataMap) {
        obj[k] = v;
      }
      // object转json
      const editDatas = JSON.stringify(obj);
      return {
        info: {
          processName: this.processName,
          ip: content.dpIp,
          port: content.dpPort,
          productVersion: content.productVersion,
          id: this.environmentId,
          data: editDatas // 页面上编辑的数据集合
        },
        vo: this.templateContent
      };
    },
    getDeployedResult() {
     /* const param = {};
      const url = `/lte/ems/deployed/queryDeployedInfoAll.html?envID=${this.environmentId}`;
      this.$axios.get(url, param).then((response) => {
        if (response && response.status === 200) {

          if (response.data.errorCode === 'SUCCESS') {
            this.hasDeployed = (response.data.resultVal.length === 0) ? false : true;
          }
        }
      });
*/
      const $this = this;
      const infoMap = new Map();
      this.axios.post('/lte/ems/deployed/queryDeployedState.html', infoMap).then(res => {
        if (res.status === 200) {
          const arrayVal = res.data.resultVal;
          if (arrayVal) { // 有响应结果
            this.hasDeployed = (arrayVal[$this.environmentId] !== undefined && arrayVal[$this.environmentId] > 0) ? true : false;
          } else {
            this.hasDeployed = false;
          }
        }
      });
    }
  },
  created() {
    // this.getDeployedInstance();
  }
};
</script>
